import { AlertTriangle } from "lucide-react";

export function PageNotice({ page }) {
  if (!page?.notice_active || !page.notice) return null;
  return (
    <div className="border-b border-amber-400/40 bg-amber-400/10" role="note" data-testid="page-notice">
      <p className="container-x flex items-start gap-3 py-3 font-mono text-xs uppercase tracking-[0.12em] text-amber-200">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />{page.notice}
      </p>
    </div>
  );
}
